module.exports = __webpack_public_path__ + "static/media/10_hiilihydraattigramman_annoksia_terveyskirjasto.f41c474b.jpg";